module.exports = __webpack_public_path__ + "img/image.7fdf2d5c.png";